/*
 * Public API Surface of ngx-scanner-qrcode
 */

export * from './lib/ngx-scanner-qrcode.component';
export * from './lib/ngx-scanner-qrcode.module';
